import {SliderWithUnit} from './SliderWithUnit';

import {typeName, qualify} from '@packages/systems/wfdl-Qualified';
import {Plugins} from '@packages/systems/wfdl';
import {TTypeConstructor} from '@packages/systems/wfdl-ast';

export const SliderCartWrapper = SliderWithUnit({
  min: 0,
  max: 1000,
  step: 50,
  inputType: TTypeConstructor(
    qualify(Plugins.name('Basic'), typeName('MSNumberCartWrapper'))
  ),
});
